// extracted by mini-css-extract-plugin
module.exports = {"Footer_hr":"FooterLayout_Footer_hr__46EaP","FooterApp_section":"FooterLayout_FooterApp_section__2elG3","FooterLegal_section":"FooterLayout_FooterLegal_section__1AWD9"};